// extracted by mini-css-extract-plugin
export var active = "_je-2";
export var recordingDot = "_je-1";
export var recordingIndicator = "_je-0";